import { render, staticRenderFns } from "./echallan.vue?vue&type=template&id=21ca3344&"
import script from "./echallan.vue?vue&type=script&lang=js&"
export * from "./echallan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports